





















































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
  @Prop() username: string;
  @Prop() loggedIn: boolean;
  @Prop() loggingIn: boolean;
  @Prop() loggingOut: boolean;
  @Prop() avatarUrl: string;
  @Emit() logIn() { return; };
  @Emit() logOut() { return; };
}
